import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchProductDetail } from "../store/actions/productAction";
import { fetchCategories } from "../store/actions/categoryAction";
import { useParams } from "react-router-dom";

export default function DetailPage() {
  let { id } = useParams();
  const dispatch = useDispatch();
  const [category, setCategory] = useState("");
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [price, setPrice] = useState("");
  const [mainImg, setMainImg] = useState("");
  const [image1, setImage1] = useState("");
  const [image2, setImage2] = useState("");
  const [image3, setImage3] = useState("");
  const [loading, setLoading] = useState(true);
  const { detailProduct } = useSelector((state) => {
    return state.products;
  });

  useEffect(() => {
    dispatch(fetchProductDetail(id));
    dispatch(fetchCategories());
    setDescription(detailProduct.description);
    setName(detailProduct.name);
    setMainImg(detailProduct.mainImg);

    if (detailProduct.Images) {
      setCategory(detailProduct.Category.name);
      setPrice(
        detailProduct.price.toLocaleString("id-ID", {
          style: "currency",
          currency: "IDR",
        })
      );
      setImage1(JSON.stringify(detailProduct.Images[0].imgUrl).slice(1, -1));
      setImage2(JSON.stringify(detailProduct.Images[1].imgUrl).slice(1, -1));
      setImage3(JSON.stringify(detailProduct.Images[2].imgUrl).slice(1, -1));
    }
    setLoading(false)
  }, [detailProduct.description]);

  if (loading) {
    return <div><h1 className="flex flex-row justify-center items-center">loading ...</h1></div>
  }


  return (
    <div>
      <hr></hr>
      <div className="container px-5 py-24 mx-auto">
        <div className="lg:w-4/5 mx-auto flex flex-wrap">
          <img
            alt="FLOWER"
            className="lg:w-1/2 w-full object-cover object-center rounded border border-gray-200"
            src={mainImg}
          />
          <div className="lg:w-1/2 w-full lg:pl-10 lg:py-6 mt-6 lg:mt-0">
            <h2 className="text-sm text-gray-500 text-left tracking-widest">
              FLOWER DETAIL
            </h2>
            <h1 className="text-gray-900 text-left text-3xl font-medium mb-1">
              {name}
            </h1>
            <div className="flex mb-4">
              <span className="flex items-center"></span>
            </div>
            <p className="leading-relaxed  text-left">{description}</p>

            <h2 className="text-gray-600  text-left mt-10 ">
              Category : {category}
            </h2>
            <div className="flex mt-6 items-center pb-5 border-b-2 border-gray-200 mb-5">
              <span className="title-font text-right font-medium text-2xl text-gray-900">
                {price}
              </span>
            </div>
            <div>
              <h2 className="text-gray-600  text-left mb-5">Other Images:</h2>
            </div>
            <div className="flex">
              <br></br>
              <img
                alt="flower"
                className="lg:w-5/12 w-36  h-44 object-cover object-center rounded border border-gray-200"
                src={image1}
              />
              <img
                alt="flower"
                className="lg:w-5/12 w-36  h-44   object-cover object-center rounded border border-gray-200"
                src={image2}
              />
              <img
                alt="flower"
                className="lg:w-5/12 w-36 h-44  object-cover object-center rounded border border-gray-200"
                src={image3}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
